<template>
  <div class="webTherapyAuditList" @scroll="handleScroll($event)">
  <div>
    <img v-show="!showList" src="@/assets/image/mobileBack.png" class="header-img" @click="back()" />
    <!-- <div class="header">
      <div class="header-font">文明旅游专栏</div>
    </div> -->
    <div class="body" v-show="showList">
      <div v-for="item in datalist" :key="item.id" class="body-card-new">
        <div style="padding:3.26vh 4.4vw 3.26vh 4.4vw" @click="open(item)">
          <div class="body-column" style="width:100%">
            <div class="body-card-title">
              {{item.title}}
            </div>
            <div style="height:1.84vh"></div>
            <div  class="body-card-introduce" >
              {{ item.biref }}
            </div>
            <div style="height:1.84vh"></div>
            <div class="body-card-time">
              {{item.showTime}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 详情 -->
    <div class="body" v-show="!showList" style="padding:4vw">
      <div style="height:5.3333vw"></div>
      <div class="body-mobile-top">
        {{ info.title }}
      </div>
      <div style="height:5.3333vw"></div>
      <div class="body-row" style="align-items:center; justify-content:center;"> 
        <div style="width:3.0666vw"></div>
        <div class="body-tittle-little">发布日期</div>
        <div style="width:1.87vw"></div>
        <div class="body-tittle-num">{{info.showTime}}</div>  

        <div style="width:1.87vw"></div>
        <div class="body-tittle-little">点击量</div>
        <div style="width:1.87vw"></div>
        <div class="body-tittle-num">{{info.hits}}</div>
      </div>
      <div style="height:5.3333vw"></div>
      <div class="body-line"></div>
      <div style="height:5.3333vw"></div>
      <div v-html="info.details" style="font-size:3.73333vw;font-weight:400;color:#071420" class="infoDetails">
        <!-- {{ info.details }} -->
      </div>
    </div>
    <div class="footer"></div>
  </div>
  </div>
</template>

<script>
import { getMenuOpenList } from "@/api/publicApi";
import  {addHits}  from "@/util/publicHits";
// import { getNationalList } from "@/api/common";
export default {
  name: "Notice",
  data() {
    return {
      current: 1,
      pageSize: 10,
      datalist: [],
      total: 0,
      showList: true,
      info: {}
    };
  },
  mounted() {
    this.getNoticeFunction()
  },
  methods: {
    handleScroll (e) {
      let el = e.target  
      //判断是否到达div容器底部
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        //控制页数 
        // this.pagesize=this.pagesize+1
        this.current = this.current + 1
        //调用后台接口
        this.getAuditRecipeList()
      }
    }, 
    // 拼接
    async getAuditRecipeList () {
      const { code, data } = await getMenuOpenList(0, 'national', this.current, 10); 
      if (code == 200 && data.records.length > 0) {
        this.datalist = this.datalist.concat(data.records)
      }
    },
    //公告
    async getNoticeFunction() {
      // const { code, data } = await getNationalList(2);
      const { code, data } = await getMenuOpenList(0,'national',1, 10); 
      if (code == 200) {
        this.datalist = data.records;
      }
    },
    open(item) {
      if(item.status === 1){
        this.info = item;
        addHits(item.id)
        this.showList = false;
      }
      if(item.status === 2){
        window.open(item.brief)
      }
    },
    back() {
      this.info = {}
      this.showList = true
    }
  }
};
</script>
<style>
.infoDetails img{
  width: 100%;
}
</style>
<style scoped>
.header {
  width: 100%;
  height: 5.7266vh;
  background: #dcdcdc;
  text-align: center;
}
.header-font {
  font-size: 2.216vh;
  line-height: 5.7266vh;
  text-align: center;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #071420;
}
.body-card-new {
  width: 91.466%;
  /* height: 17.733vh; */
  background: #f6faff;
  border-radius: 4.266vw;
  margin: 4.2666vw 4.2666vw 0 4.2666vw;
}
.footer {
  height: 4.2666vw;
}
.body-row {
  display: flex;
  flex-direction: row;
}
.body-column {
  display: flex;
  flex-direction: column;
}
.body-img {
  width: 32vw;
  height: 11.33vh;
  border-radius: 2.1333vw;
}
.body-card-title {
  font-size: 4.266vw;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #071420;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.body-card-introduce {
  font-size: 3.466vw;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #334251;
  /* height: 3.31vh; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.body-card-time {
  font-size: 3.2vw;
  font-family: "IcedEarth";
  font-weight: normal;
  color: #8b939a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header-img {
  width: 4.6666vw;
  height: 4.6666vw;
  position: absolute;
  z-index: 1;
  top: 4vw;
  left: 4vw;
}
.body-mobile-top {
  font-size: 4.2666vw;
  font-family: "Source Han Sans CN";
  font-weight: 500;
  color: #071420;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.body-tittle-num {
  font-size: 3.733vw;
  font-family: "IcedEarth";
  font-weight: normal;
  color: #071420;
}
.body-tittle-little {
  font-size: 3.733vw;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #8b939a;
}
.body-line {
  width: 100%;
  height: 0.1333vw;
  text-align: center;
  border-bottom: 1px dashed #8b939a;
}
.box1 {
  width: 300px;
  height: 50px;
  text-align: center;
  padding-top: 30px;
  border-bottom: 2px dashed #000;
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/national.vue